import { API_URL } from '@/lib/api';

// ─── Trail Reviews API Functions ─────────────────────────────────────

export interface TrailReview {
  id: string;
  rating: number;
  content?: string;
  createdAt?: string;
  updatedAt?: string;
}

export async function fetchTrailReviews(trailId: string, token?: string): Promise<TrailReview[]> {
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(`${API_URL}/trail/${trailId}/reviews`, { headers });
  if (!response.ok) {
    const body = await response.text().catch(() => '');
    throw new Error(`Failed to load trail reviews (${response.status}): ${body}`);
  }
  const data = await response.json();
  return Array.isArray(data) ? data : [];
}

export async function submitTrailReview(
  trailId: string,
  token: string,
  review: { rating: number; content?: string },
): Promise<TrailReview> {
  const response = await fetch(`${API_URL}/trail/${trailId}/reviews`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(review),
  });
  if (!response.ok) {
    const body = await response.text().catch(() => '');
    throw new Error(`Failed to submit review (${response.status}): ${body}`);
  }
  return response.json();
}